import React from 'react';
import { Navigation, NavigationProps } from './Navigation';

interface InsightsWidgetFooterProps extends NavigationProps {
  rightActionButton?: React.ReactNode;
  showNavigation?: boolean;
}

export const InsightsWidgetFooter = (navOptions : InsightsWidgetFooterProps) => {
  const { rightActionButton, showNavigation, ...rest } = navOptions;
  return (
    <>
      <div className='border-b border-bw06 opacity-30 font-metricMedium flex w-full mb-[14px]' />
      <div className='flex justify-between items-center h-[30px]'>
        <div className={`${showNavigation ? 'invisible' : 'visible'}`}>
          <Navigation {...rest} />

        </div>
        {rightActionButton && rightActionButton}
      </div>
    </>
  );
};
